export default class ScrollingMarquee {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        marquees: [],
        isRunning: false,
        scrollStep: 2
      };

      this.setupMarquees();
      this.setupEventListeners();
    }
  }

  // ==========================================================================
  // Sets up the marquee
  // ==========================================================================

  setupMarquees() {
    const $marquees  = $('.js-marquee');
    const marqueeArr = [];

    $marquees.each((i, marquee) => {
      let $marquee  = $(marquee);
      let content   = $marquee.closest('.js-marquee-wrapper').find('.js-marquee-content-wrapper').html();
      let direction = $marquee.data('direction');

      $marquee.html(content);

      let width = $marquee.find('.js-marquee-content').width() + 1;
      let state = {
        $marquee: $marquee,
        width: width,
        marginOffset: 0,
        direction: direction === 'right' ? 'right' : 'left'
      };

      $marquee.append(content);
      marqueeArr.push(state);
    });

    this.state.marquees = marqueeArr;
    $marquees.addClass('active');

    if (this.state.marquees.length && !this.state.isRunning) {
      this.state.isRunning = true;
      this.scrollAllMarquees();
    } else if (!this.state.marquees.length) {
      this.state.isRunning = false;
    }
  }

  // ==========================================================================
  // Scrolls each marquee in the state marquees array.
  // ==========================================================================

  scrollAllMarquees() {
    if (!this.state.marquees.length) { return; }

    this.state.marquees.forEach((marqueeObj) => {
      if (marqueeObj.direction == 'right') {
        this.scrollMarqueeRight(marqueeObj);
      } else {
        this.scrollMarqueeLeft(marqueeObj);
      }
    });

    setTimeout(() => {
      this.scrollAllMarquees();
    }, 50);
  }

  // ==========================================================================
  // Scrolls a single marquee to the left
  // ==========================================================================

  scrollMarqueeLeft(marqueeObj) {
    if (!marqueeObj) { return; }

    if (marqueeObj.marginOffset < marqueeObj.width) {
      marqueeObj.marginOffset += this.state.scrollStep;
    } else {
      marqueeObj.marginOffset = 1;
    }

    marqueeObj.$marquee.css({ marginLeft: `-${ marqueeObj.marginOffset }px` });
  }

  // ==========================================================================
  // Scrolls a single marquee to the right
  // ==========================================================================

  scrollMarqueeRight(marqueeObj) {
    if (!marqueeObj) { return; }

    if (marqueeObj.marginOffset <= 1) {
      marqueeObj.marginOffset = marqueeObj.width;
    } else {
      marqueeObj.marginOffset -= this.state.scrollStep;
    }

    marqueeObj.$marquee.css({ marginLeft: `-${ marqueeObj.marginOffset }px` });
  }

  // ==========================================================================
  // Extends the marquee template by repeating the text to cover the page width
  // ==========================================================================

  makeContentTemplate(content) {
    const space = '&nbsp;&nbsp;&nbsp;&nbsp;';
    let extended = '<span class="scrolling-marquee--content js-marquee-content">';

    if (!content) { return ''; }

    for (let i = 0; i < 10; i++) {
      extended += `<span>${ space }${ content }${ space }</span>`;
    }

    extended += '</span>';

    return extended;
  }

  // ==========================================================================
  // Stops the marquees during page transitions
  // ==========================================================================

  stopMarquees() {
    this.state.marquees  = [];
    this.state.isRunning = false;
  }

  // ==========================================================================
  // Freezes the marquees on mouse enter
  // ==========================================================================

  freezeMarquees() {
    this.state.scrollStep = 0;
  }

  // ==========================================================================
  // Freezes the marquees on mouse leave
  // ==========================================================================

  unfreezeMarquees() {
    this.state.scrollStep = 3;
  }

  // ==========================================================================
  // Sets up the Event Listeners
  // ==========================================================================

  setupEventListeners() {
    $(document).on('mouseenter', '.js-marquee', this.freezeMarquees.bind(this));
    $(document).on('mouseleave', '.js-marquee', this.unfreezeMarquees.bind(this));
    $(document).on('historyChange', this.setupMarquees.bind(this));
    $(window).on('resize', this.setupMarquees.bind(this));
  }
}
